/* global axios */
import ApiClient from '../ApiClient';

export default class WgptExecutionsAPI extends ApiClient {
  constructor() {
    super('task_executions', {
      accountScoped: true,
      wgpt: true,
    });
  }

  get(params) {
    return axios.get(this.url, { params });
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  runNow(id) {
    return axios.post(`${this.url}/${id}/run_now`);
  }
}
